import { Directive, ElementRef, HostListener, Input, NgModule } from "@angular/core";

// color and trim() input
@Directive({
    selector: "input[customInput]",
})
export class CustomInputDirective {
    constructor(private el: ElementRef) {
    }
    @Input() selectAllOnFocus = false;
    @Input() trimValue = true;
    @Input() upperCase = false;
    @Input() removeZezo = true;
    @Input() isNumber = false;

    @HostListener('focus') onFocus() {
        this.el.nativeElement.style.backgroundColor = "yellow";
        if(this.selectAllOnFocus){
            this.el.nativeElement.select();
        }
        if(this.isNumber && this.removeZezo){
            if(this.el.nativeElement.value == 0){
                this.el.nativeElement.value = null;
            }
        }
      }
    @HostListener('blur') onBlur() {
        this.el.nativeElement.style.backgroundColor = "white";
        if(this.trimValue){
            this.el.nativeElement.value = this.el.nativeElement.value.trim();
        }
        if(this.upperCase){
        this.el.nativeElement.value = this.el.nativeElement.value.toUpperCase();
        }
        if(this.isNumber && this.removeZezo){
            if(this.el.nativeElement.value == null){
                this.el.nativeElement.value = 0;
            }
        }
    }

}

@NgModule({
    imports: [
    ],
    declarations: [
        CustomInputDirective,
    ],
    exports: [
        CustomInputDirective,
    ]
})
export class CustomInputModule {

}